"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    duration: 250,
    nudge: true,
    reverseOut: true,
    effects: "fade",
    easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
};
